import axiosInstance from "./AxiosInstance";

export function getQuestionnaire(leadId) {
  return axiosInstance.post("/lead/questionnaire", { lead_id: leadId });
}

export function saveQuestionnaireAnswers(payload) {
  return axiosInstance.post("/lead/saveQuestionAnswer", payload);
}

export function getAnswerList(payload) {
  return axiosInstance.post("/admin/answerList", payload);
}

export function saveAnswerList(payload) {
  return axiosInstance.post("/admin/updatePatientFormAnswer", payload);
}

// New function to save answers with transformed payload format
export function saveTransformedAnswerList(payload) {
  // You can change this endpoint to match your backend's expected endpoint
  return axiosInstance.post("/admin/updatePatientFormAnswer", payload);
}

// Alternative function for a different endpoint if needed
export function saveQuestionsWithNewFormat(payload) {
  return axiosInstance.post("/admin/saveQuestions", payload);
}

export function formatAnswerList(responseData) {
  return responseData.data || [];
}
